<template>
  <div class="wrapper fm-shell">
    <!-- ===== TOP BAR ===== -->
    <header class="fm-topbar">
      <div class="fm-topbar-left">
        <div class="fm-logo"><i class="fa-solid fa-shield-halved"></i></div>
        <span class="fm-brand">CloudAM</span>
      </div>
      <div class="fm-topbar-right">
        <a href="https://docs.acceldata.io" target="_blank" rel="noopener" class="fm-topbar-link">
          <i class="fa-solid fa-book"></i>Docs
        </a>
        <div class="fm-status"><span class="fm-status-live"></span>Operational</div>
        <div class="fm-topbar-sep"></div>
        <b-dropdown right no-caret variant="link" toggle-class="p-0 border-0">
          <template #button-content>
            <div class="fm-avatar">{{ initials }}</div>
          </template>
          <b-dropdown-item to="/account"><i class="fa-solid fa-user mr-2"></i>Account</b-dropdown-item>
          <b-dropdown-item to="/settings"><i class="fa-solid fa-gear mr-2"></i>Settings</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="logout"><i class="fa-solid fa-right-from-bracket mr-2"></i>Log out</b-dropdown-item>
        </b-dropdown>
      </div>
    </header>

    <!-- ===== SECTION TABS ===== -->
    <nav class="fm-tabs">
      <router-link
        v-for="tab in tabs"
        :key="tab.to"
        :to="tab.to"
        class="fm-tab"
        :class="{ 'fm-tab--active': isActive(tab.to) }">
        <i class="fa-solid" :class="tab.icon"></i>{{ tab.label }}
      </router-link>
    </nav>

    <!-- ===== BODY (rail + main provided per page) ===== -->
    <div class="fm-body">
      <dashboard-content @click="toggleSidebar"></dashboard-content>
    </div>
  </div>
</template>

<script>
  import DashboardContent from './Content.vue'

  export default {
    components: {
      DashboardContent
    },
    data() {
      return {
        tabs: [
          { to: '/overview', label: 'Overview', icon: 'fa-gauge-high' },
          { to: '/agents', label: 'Agents', icon: 'fa-microchip' },
          { to: '/services', label: 'Services', icon: 'fa-cubes' },
          { to: '/users', label: 'Users', icon: 'fa-users' },
          { to: '/access', label: 'Access', icon: 'fa-key' },
          { to: '/roles', label: 'Roles', icon: 'fa-user-shield' },
          { to: '/audit', label: 'Audit Log', icon: 'fa-clipboard-check' },
          { to: '/logs', label: 'Logs', icon: 'fa-list' },
          { to: '/network', label: 'Network', icon: 'fa-diagram-project' }
        ]
      }
    },
    computed: {
      initials() {
        const email = localStorage.getItem('userEmail') || ''
        const base = email.split('@')[0] || 'AD'
        const parts = base.split(/[.\-_]/).filter(Boolean)
        const letters = parts.length > 1 ? parts[0][0] + parts[1][0] : base.slice(0, 2)
        return letters.toUpperCase()
      }
    },
    methods: {
      isActive(to) {
        const path = this.$route.path
        return path === to || path.startsWith(to + '/')
      },
      toggleSidebar() {
        if (this.$sidebar && this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      logout() {
        localStorage.removeItem('authToken')
        window.location.href = '/login'
      }
    }
  }
</script>
